import React, { useMemo } from "react";
import useTableInstance from "hooks/useTableInstance";
import Pagination from "components/Common/Pagination/index";
import TableContainer from "./TableContainerResultEntryInsideRow";
import "../../../styles/components/table.scss";

function Table(props) {
  const {
    data: tableData,
    isLoading,
    tableColumns,
    TableColumnFilter,
    enableSorting = false,
    currentPage,
    disablePrev,
    disableNext,
    totalPages,
    loadNextPage,
    loadPreviousPage,
    totalRecords,
    showPagination = true,
    getRowProps = () => ({}),
    renderExpandedRow,
    expandedRowId,
    setExpandedRowId,
  } = props;
  const defaultColumn = useMemo(
    () => ({
      Filter: TableColumnFilter,
    }),
    [],
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    paginationPageRows,
    prepareRow,
  } = useTableInstance(tableColumns, tableData, defaultColumn, enableSorting);

  return (
    <>
      <TableContainer
        getRowProps={getRowProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        rows={paginationPageRows}
        getTableProps={getTableProps}
        prepareRow={prepareRow}
        isLoading={isLoading}
        totalRecords={totalRecords}
        tableData={tableData}
        renderExpandedRow={renderExpandedRow}
        expandedRowId={expandedRowId}
        setExpandedRowId={setExpandedRowId}
      />
      {tableData.length !== 0 && showPagination && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          loadPreviousPage={loadPreviousPage}
          loadNextPage={loadNextPage}
          disablePrev={disablePrev}
          disableNext={disableNext}
        />
      )}
    </>
  );
}

export default Table;
